import {createSelector} from 'reselect';


const selectModals = state => state.modals;


export const selectRepresentationModal = createSelector(
    [selectModals],
    modals => modals.representationModal
);
export const selectFaqQuestion = createSelector(
    [selectModals],
    modals => modals.faqQuestion
);
export const selectFirstPin = createSelector(
    [selectModals],
    modals => modals.firstPin
);